import { ButtonPrimary } from '@/components/button'
import { Close } from '@/components/icons'
import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  open: 'END' | 'REOPEN' | ''
  onClose: () => void
  onSubmit: () => any
}

export const EndReopenBracketModal = ({ open, onClose, onSubmit }: Props) => {
  const { t } = useTranslation()

  return (
    <Transition appear show={!!open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full flex flex-col gap-y-4 max-w-lg transform overflow-hidden rounded-2xl bg-white px-6 py-4 text-left align-middle shadow-xl transition-all relative">
                <button
                  className="w-9 h-9 rounded-full bg-navy-900 bg-opacity-10 flex items-center justify-center ml-2 hover:bg-opacity-20 absolute right-2 top-2"
                  onClick={onClose}
                >
                  <Close className="text-navy-900" />
                </button>

                <Dialog.Title as="h3" className="text-xl text-navy-900 font-semibold">
                  {open === 'END' ? t('event.endBracket') : t('event.reopenBracket')}
                </Dialog.Title>

                {open === 'END' ? (
                  <>
                    <h3 className="text-sm font-semibold text-navy-900 text-center">
                      {t('event.endBracketModalTitle')}
                    </h3>
                    <span className="text-sm text-gray-500">
                      <span className="font-bold">{t('common.warning')}:</span> {t('event.endBracketModalDesc')}
                    </span>
                  </>
                ) : (
                  <span className="text-sm text-gray-500 text-center">{t('event.reopenBracketDesc')}</span>
                )}

                <div className="flex  justify-center gap-x-4">
                  <button
                    onClick={onClose}
                    className="bg-navy-900 hover:bg-opacity-20 bg-opacity-10 py-1 w-24 rounded text-sm text-navy-900 font-semibold"
                  >
                    {open === 'END' ? t('common.cancel') : t('common.goBack')}
                  </button>
                  <ButtonPrimary
                    title={open === 'END' ? t('event.endBracket') : t('common.confirm')}
                    className={`!py-[6px] !px-4 !rounded`}
                    onClick={onSubmit}
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
